if (!customElements.get('abok-manual-library')) {
  customElements.define(
    'abok-manual-library',
    class AbokManualLibrary extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.groups = Array.from(this.querySelectorAll('[data-manual-group]'));
        this.filterButtons = Array.from(
          this.querySelectorAll('[data-manual-filter-all], [data-manual-filter-category]')
        );
        this.status = this.querySelector('[data-manual-status]');
        this.empty = this.querySelector('[data-manual-empty]');

        this.filterButtons.forEach((button) => {
          button.addEventListener('click', () => this.handleFilter(button));
        });

        const initialButton = this.filterButtons.find((button) => button.dataset.manualFilterCategory);
        const initialCategory = initialButton?.dataset.manualFilterCategory || '';
        this.applyFilter(initialCategory, '');
      }

      handleFilter(button) {
        const category = button.dataset.manualFilterCategory || '';
        const product = button.dataset.manualFilterProduct || '';
        this.applyFilter(category, product);

        const firstVisibleGroup = this.groups.find((group) => !group.hidden);
        if (firstVisibleGroup && window.matchMedia('(max-width: 749px)').matches) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          firstVisibleGroup.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }

      applyFilter(category, product) {
        let visibleDocuments = 0;

        this.groups.forEach((group) => {
          const categoryMatches = !category || group.dataset.manualCategory === category;
          const productMatches = !product || group.dataset.manualProduct === product;
          const visible = categoryMatches && productMatches;

          group.hidden = !visible;
          if (visible) {
            visibleDocuments += group.querySelectorAll('.abok-manual-document').length;
          }
        });

        this.filterButtons.forEach((button) => {
          const buttonCategory = button.dataset.manualFilterCategory || '';
          const buttonProduct = button.dataset.manualFilterProduct || '';
          const isActive = buttonCategory === category && buttonProduct === product;

          button.setAttribute('aria-pressed', String(isActive));
          button.classList.toggle('is-active', isActive);
        });

        if (this.status) {
          const noun = visibleDocuments === 1 ? 'document' : 'documents';
          this.status.textContent = `${visibleDocuments} ${noun}`;
        }

        if (this.empty) {
          this.empty.hidden = visibleDocuments > 0;
        }
      }
    }
  );
}
